<template>
  <div style="margin-top: 50px;">
    <span style='font-size:100px;'>&#128586;</span>
    <div style="font-size: 32px;">
      {{$t('message.Error_title')}}
    </div>
    <div style="margin-top: 20px; font-size: 18px;">
      <div>
        {{$t('message.Error_message_1')}}
      </div>
      <div>
        <el-link @click="goHome" type="primary" :underline="false" style="font-size: 18px">{{$t('message.Error_message_2')}}</el-link>
      </div>
      <div>
        <el-link href="mailto:xiaoyu.yan@jcdecaux.com" type="primary" :underline="false" style="font-size: 18px">{{$t('message.Error_message_3')}}</el-link>
      </div>
    </div>
  </div>
</template>

<script>
  import _global from './components/global.vue';
  export default {
    name: 'eroor',
    data() {
      return {
        home_url: _global.serverSrc.substring(0, -4) + '/choose_city/',
      }
    },
    created() {
      this.$i18n.locale = JSON.parse(sessionStorage.getItem('lang'))
    },
    mounted() {
    },
    methods: {
      goHome() {
      this.$router.push({
          path: '/choose_city',
        });
      }
    }
  }
</script>

<style lang="scss">
  /deep/.el-link.el-link--primary:hover {
    color: #0056b3
  }
</style>